import React from 'react'
import { useAtom, useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { contentUpdatesAtom, currentlyBusyAtom, excludedAtom } from './atoms'
import { useUpdateAllFunc } from './utility'
import { Box, Button } from '@mui/material'
import { Table } from 'shared/ui/Table/Table'
import { ConfirmCommitButton } from 'shared/ui'
import { includedColumns } from './tableColumns'

export function ReplacementTable() {
  const { included: replacementData } = useAtomValue(contentUpdatesAtom)
  return (
    <Box>
      <Table
        title={`Updating Total: ${replacementData.length}`}
        columns={includedColumns}
        items={replacementData}
        toolBarItems={[
          <ExcludeAllButton key="exclude" />,
          <UpdateAllButton key="update" />,
        ]}
      />
    </Box>
  )
}

function ExcludeAllButton() {
  const { included } = useAtomValue(contentUpdatesAtom)
  const [, setExcluded] = useAtom(excludedAtom)
  const doExclude = () =>
    setExcluded((prev) => [...prev, ...included.map(({ node: { id } }) => id)])
  return <Button onClick={doExclude}>Exclude All</Button>
}

function UpdateAllButton() {
  const busy = useAtomValue(currentlyBusyAtom)
  const updateAllFunc = useUpdateAllFunc()
  return (
    <ConfirmCommitButton
      disabled={busy}
      key="updateAll"
      onClick={updateAllFunc}
    >
      Update All
    </ConfirmCommitButton>
  )
}
